import { render, staticRenderFns } from "./photo-loader.vue?vue&type=template&id=3f4e4460&scoped=true"
import script from "./photo-loader.vue?vue&type=script&lang=js"
export * from "./photo-loader.vue?vue&type=script&lang=js"
import style0 from "./photo-loader.vue?vue&type=style&index=0&id=3f4e4460&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4e4460",
  null
  
)

export default component.exports